import { jsx as _jsx } from "react/jsx-runtime";
import { HXToggleSwitchEl } from "./HXToggleSwitch.styles";
export const HXToggleSwitch = (props) => {
    return _jsx(HXToggleSwitchEl, { ...props });
};
